import dayjs from "dayjs"

// YYYY-MM-DD
export type DateString = string

const dateFormat = "YYYY-MM-DD"

/**
 * dayjs.DayjsをYYYY-MM-DDの文字列に変換する
 */
export const formatDate = (date: dayjs.Dayjs): DateString =>
    date.format(dateFormat)
